import React, { ComponentPropsWithoutRef } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DomainObject,
  ScrollableSource,
  TableFieldColumn,
} from '@eas/common-web';
import { CollectionField } from '@components/collection-field/collection-field';
import { DictionaryAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';
import { useColumns } from './defect-columns';
import DefectUpdateDialog from './defect-detail-dialog';

interface DefectFieldProps
  extends Partial<
    ComponentPropsWithoutRef<typeof CollectionField<DictionaryAutocomplete>>
  > {
  source: ScrollableSource<DictionaryAutocomplete>;
  hideRedirectInCurrent?: boolean;
}

export function DefectField({
  source,
  hideRedirectInCurrent,
  ...overrides
}: DefectFieldProps) {
  return (
    <CollectionField<DictionaryAutocomplete>
      title={
        <FormattedMessage
          id="ZSD__FIELD_LABEL__DEFECTS"
          defaultMessage="Nedostatky"
        />
      }
      source={source}
      columnsProps={{ hideRedirectInCurrent }}
      useColumns={
        useColumns as <T extends DomainObject>() => TableFieldColumn<T>[]
      }
      disabled={false}
      createAction={{
        hide: true,
        getUrl: () => EvidenceApiUrl.DEFECTS,
      }}
      readAction={{
        getUrl: (collectionId) => `${EvidenceApiUrl.DEFECTS}/${collectionId}`,
      }}
      updateAction={{
        hide: false,
        Dialog: () => DefectUpdateDialog(),
        dialogWidth: 700,
        label: 'Zobraziť detail',
        title: 'Detail nedostatku',
        text: '',
        dialogShowConfirm: false,

        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.DEFECTS}/${collectionId}`,
      }}
      deleteAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.DEFECTS}/${collectionId}`,
      }}
      assignAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.DEFECTS}/${collectionId}`,
      }}
      unassignAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.DEFECTS}/${collectionId}`,
      }}
      {...overrides}
    />
  );
}
